// Conversion utilities between stored DB units (lbs, km) and display units (kg, mi)
export function lbsToKg(lbs) {
  if (lbs === null || lbs === undefined || lbs === '') return lbs;
  const n = Number(lbs);
  if (isNaN(n)) return lbs;
  return +(n * 0.45359237).toFixed(1);
}

export function kgToLbs(kg) {
  if (kg === null || kg === undefined || kg === '') return kg;
  const n = Number(kg);
  if (isNaN(n)) return kg;
  return +(n / 0.45359237).toFixed(1);
}

/**
 * Format a weight value to have at most 1 decimal place.
 * Useful for displaying weights after conversions or calculations.
 */
export function formatWeight(value) {
  if (value === null || value === undefined || value === '') return value;
  const n = Number(value);
  if (isNaN(n)) return value;
  // Remove trailing .0 for cleaner display
  const fixed = n.toFixed(1);
  return fixed.endsWith('.0') ? String(Math.round(n)) : fixed;
}

export function kmToMiles(km) {
  if (km === null || km === undefined || km === '') return km;
  const n = Number(km);
  if (isNaN(n)) return km;
  return +(n * 0.62137119).toFixed(2);
}

export function milesToKm(mi) {
  if (mi === null || mi === undefined || mi === '') return mi;
  const n = Number(mi);
  if (isNaN(n)) return mi;
  return +(n / 0.62137119).toFixed(2);
}

export function metersToFeet(meters) {
  if (meters === null || meters === undefined || meters === '') return meters;
  const n = Number(meters);
  if (isNaN(n)) return meters;
  return +(n * 3.280839895).toFixed(2);
}

export function feetToMeters(feet) {
  if (feet === null || feet === undefined || feet === '') return feet;
  const n = Number(feet);
  if (isNaN(n)) return feet;
  const meters = n / 3.280839895;
  const nearestWholeMeter = Math.round(meters);
  // metersToFeet displays hundredths, so an exact whole-meter value can return
  // up to half a hundredth of a foot away after the user edits that display.
  const wholeMeterSnapThreshold = 0.005 / 3.280839895;
  if (Math.abs(meters - nearestWholeMeter) <= wholeMeterSnapThreshold) return nearestWholeMeter;
  return +meters.toFixed(3);
}
